export const IMPLEMENTATION_FORM_EVENT_TYPES = {
  SAVE: 'save',
  SAVE_AND_FORWARD: 'save_forward',
} as const;
